<template>
  <div class="columns">
    <div class="column is-6">
      <div class="columns">
        <div class="column is-4 has-text-centered-touch is-paddingless">
          <img :src="logo">
        </div>
        <div class="column is-8 detail has-text-centered is-paddingless">
          <p v-html="notes" />
        </div>
      </div>
    </div>
    <div class="column is-6 is-paddingless">
      <div class="comment">
        <div class="comment-heading columns">
          <div class="column is-12 card-header has-text-centered">
            <strong>Session Times</strong>
          </div>
        </div>
        <div class="card-content is-flex flex-wrap">
          <div
            v-for="session in sessionTimes"
            class="session-time"
          >
            <strong>{{ session.weekday }}</strong>
            <p class="has-text-danger">
              {{ session.mark }}
            </p>
            <p>{{ session.sessionTimes }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['logo', 'notes', 'sessionTimes']
  }
</script>